import { eventEmitter } from './ga';

const getUser = () => JSON.parse(localStorage.getItem('user_data') || '');

export const joinMeetingClickEvent = () => {
  eventEmitter({
    action: 'join_meeting_click_event',
    event_category: 'zipmeet_call_joining',
    event_label: 'join meeting click event',
  });
};

export const zipmeetAudioToggleEvent = (eventName: string) => {
  const audioEventMap: any = {
    off: { action: 'zipmeet_mute_event', label: 'zipmeet muted' },
    on: { action: 'zipmeet_unmute_event', label: 'zipmeet unmuted' },
  };

  const eventAction: string = audioEventMap[eventName]
    ? audioEventMap[eventName].action
    : '';
  const eventLabel: string = audioEventMap[eventName]
    ? audioEventMap[eventName].label
    : '';

  if (eventAction !== '' && eventLabel !== '') {
    eventEmitter({
      action: eventAction,
      event_category: 'zipmeet_call_joining',
      event_label: eventLabel,
    });
  }
};

export const zipmeetVideoToggleEvent = (eventName: string) => {
  const videoEventMap: any = {
    on: { action: 'zipmeet_video_toggle_on_event', label: 'zipmeet video on' },
    off: {
      action: 'zipmeet_video_toggle_off_event',
      label: 'zipmeet video off',
    },
  };

  const eventAction: string = videoEventMap[eventName]
    ? videoEventMap[eventName].action
    : '';
  const eventLabel: string = videoEventMap[eventName]
    ? videoEventMap[eventName].label
    : '';

  if (eventAction !== '' && eventLabel !== '') {
    eventEmitter({
      action: eventAction,
      event_category: 'zipmeet_call_joining',
      event_label: eventLabel,
    });
  }
};

export const endCallClickedEvent = () => {
  eventEmitter({
    action: 'end_call_clicked_event',
    event_category: 'zipmeet_call',
    event_label: 'end call clicked event',
  });
};

export const stopRecordingClickEvent = () => {
  const user = getUser();
  eventEmitter({
    action: 'stop_recording_click',
    event_category: 'zipmeet_call',
    event_label: 'Stop Recording Clicked',
    user_id: user?.id,
  });
};

export const startRecordingClickEvent = () => {
  const user = getUser();
  eventEmitter({
    action: 'start_recording_click',
    event_category: 'zipmeet_call',
    event_label: 'Start Recording Clicked',
    user_id: user?.id,
  });
};

export const stopRecordingConfirmClickEvent = () => {
  const user = getUser();
  eventEmitter({
    action: 'stop_recording_confirm_click',
    event_category: 'zipmeet_call',
    event_label: 'Stop Recording - Confirm Clicked',
    user_id: user?.id,
  });
};

export const stopRecordingCancelClickEvent = () => {
  const user = getUser();
  eventEmitter({
    action: 'stop_recording_cancel_click',
    event_category: 'zipmeet_call',
    event_label: 'Stop Recording - Cancel Clicked',
    user_id: user?.id,
  });
};

export const openedTCEvent = () => {
  eventEmitter({
    action: 'opened_tc_event',
    params: {
      event_category: 'auth',
      event_label: 'opened tc event',
    },
  });
};

export const openedPrivacyPolicyEvent = () => {
  eventEmitter({
    action: 'opened_privacy_policy_event',
    params: {
      event_category: 'auth',
      event_label: 'opened privacy policy event',
    },
  });
};

export const singleParticipantModalContinue = () => {
  eventEmitter({
    action: 'single_participant_continue_click',
    params: {
      event_category: 'zipmeet_call',
      event_label: 'single participant modal continue clicked',
    },
  });
};

export const singleParticipantModalCancel = () => {
  eventEmitter({
    action: 'single_participant_cancel_click',
    params: {
      event_category: 'zipmeet_call',
      event_label: 'single participant modal cancel clicked',
    },
  });
};
